import { render, staticRenderFns } from "./ScannerForm.vue?vue&type=template&id=06b96b92&scoped=true&lang=pug&"
import script from "./ScannerForm.vue?vue&type=script&lang=js&"
export * from "./ScannerForm.vue?vue&type=script&lang=js&"
import style0 from "./ScannerForm.vue?vue&type=style&index=0&id=06b96b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b96b92",
  null
  
)

export default component.exports